module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/th/6-a50d7d577211f93df973bd305d1b2bd8.jpg";